
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tx/[hash]",
      function () {
        return require("private-next-pages/tx/[hash].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tx/[hash]"])
      });
    }
  